import { render, staticRenderFns } from "./EditSalonHome.vue?vue&type=template&id=f6825546"
import script from "./EditSalonHome.vue?vue&type=script&lang=js"
export * from "./EditSalonHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports